import _ from "lodash";
import { getIn } from "formik";
import React from "react";

import { RadioGroup, RadioOld, Text, TextColors, TextTypes } from "../../../component-library";

import "./styles.scss";

// NOTE: THIS PATTERN WAS COPIED FROM the care management form
export const WaitlistFormRadioField = ({
  formikProps,
  handleChange: externalHandleChange,
  name,
  radioOptions = [],
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);

  const handleChange = async (event) => {
    await externalHandleChange(event);
    await formikProps.setFieldValue(name, event.target.value);
  };

  return (
    <>
      <RadioGroup
        className="WaitlistPage--patient-state"
        name={name}
        onChange={handleChange}
        value={_.get(formikProps.values, name)}
      >
        {radioOptions.map((option) => {
          return (
            <RadioOld
              className="WaitlistPage--patient-state-label mb-2"
              key={option.value}
              label={option.label}
              labelClassName="font-weight-normal"
              radioClassName="font-weight-normal"
              value={option.value}
              version="v2"
            />
          );
        })}
      </RadioGroup>
      {errorMessage && isTouched && (
        <Text className="pt-2" color={TextColors.red} type={TextTypes.small}>
          {errorMessage}
        </Text>
      )}
    </>
  );
};
